<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.LESSONS' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'موضوع الفقه' : 'Fiqh Topic' }}
  </label>

  <select
    class="form-control"
    [(ngModel)]="formData.fiqh_topic_id"
    name="fiqh_topic_id">

    <option value="">
      {{ lang === 'ar' ? 'اختر الموضوع' : 'Select Topic' }}
    </option>

    <option *ngFor="let topic of topics" [value]="topic.id">
      {{ topic.name }}
    </option>

  </select>

  <small class="text-danger" *ngIf="errors?.fiqh_topic_id">
    {{ errors.fiqh_topic_id[0] }}
  </small>
</div>


<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'عنوان الدرس' : 'Lesson Title' }}
  </label>

  <input
    type="text"
    class="form-control"
    [(ngModel)]="formData.title"
    name="title"
  />

  <small class="text-danger" *ngIf="errors?.title">
    {{ errors.title[0] }}
  </small>
</div>


<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'محتوى الدرس' : 'Lesson Content' }}
  </label>

  <textarea
    class="form-control"
    rows="4"
    [(ngModel)]="formData.content"
    name="content">
  </textarea>

  <small class="text-danger" *ngIf="errors?.content">
    {{ errors.content[0] }}
  </small>
</div>
          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
